const parentFolder = 'animation/pe/a2/'
export default  {
  v: '5.9.0',
  fr: 29.9700012207031,
  ip: 0,
  op: 381.000015518448,
  w: 850,
  h: 700,
  nm: 'Animacion-premios',
  ddd: 0,
  assets: [
    { id: 'image_0', w: 542, h: 274, u: parentFolder, p: 'img_0.png', e: 0 },
    { id: 'image_1', w: 610, h: 188, u: parentFolder, p: 'img_1.png', e: 0 },
    { id: 'image_2', w: 610, h: 188, u: parentFolder, p: 'img_2.png', e: 0 },
    { id: 'image_3', w: 301, h: 307, u: parentFolder, p: 'img_3.png', e: 0 },
    { id: 'image_4', w: 610, h: 188, u: parentFolder, p: 'img_4.png', e: 0 },
    { id: 'image_5', w: 486, h: 250, u: parentFolder, p: 'img_5.png', e: 0 },
    { id: 'image_6', w: 280, h: 290, u: parentFolder, p: 'img_6.png', e: 0 },
    { id: 'image_7', w: 610, h: 188, u: parentFolder, p: 'img_7.png', e: 0 },
    { id: 'image_8', w: 914, h: 758, u: parentFolder, p: 'img_8.png', e: 0 },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 2,
      nm: 'Group 45046.png',
      cl: 'png',
      refId: 'image_0',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [441, 394, 0], ix: 2, l: 2 },
        a: { a: 0, k: [271, 137, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 279,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 297,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.567, 0.567, 0.667], y: [1, 1, 1] },
              o: { x: [0.441, 0.441, 0.333], y: [0, 0, 0] },
              t: 315,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 372,
              s: [100, 100, 100],
            },
            { t: 381.000015518448, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 279.000011363903,
      op: 1780.00007250089,
      st: 279.000011363903,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 2,
      nm: 'Group 45050.png',
      cl: 'png',
      refId: 'image_1',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [425, 110, 0], ix: 2, l: 2 },
        a: { a: 0, k: [305, 94, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 279,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 297,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.567, 0.567, 0.667], y: [1, 1, 1] },
              o: { x: [0.441, 0.441, 0.333], y: [0, 0, 0] },
              t: 315,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 372,
              s: [100, 100, 100],
            },
            { t: 381.000015518448, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 279.000011363903,
      op: 1780.00007250089,
      st: 279.000011363903,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 2,
      nm: 'Group 45049.png',
      cl: 'png',
      refId: 'image_2',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [425, 114, 0], ix: 2, l: 2 },
        a: { a: 0, k: [305, 94, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 186,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 204,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.567, 0.567, 0.667], y: [1, 1, 1] },
              o: { x: [0.441, 0.441, 0.333], y: [0, 0, 0] },
              t: 222,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 279,
              s: [100, 100, 100],
            },
            { t: 288.00001173048, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 186.000007575935,
      op: 1687.00006871292,
      st: 186.000007575935,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 2,
      nm: 'Group 45032.png',
      cl: 'png',
      refId: 'image_3',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [425, 386, 0], ix: 2, l: 2 },
        a: { a: 0, k: [150.5, 153.5, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 186,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 204,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.567, 0.567, 0.667], y: [1, 1, 1] },
              o: { x: [0.441, 0.441, 0.333], y: [0, 0, 0] },
              t: 222,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 279,
              s: [100, 100, 100],
            },
            { t: 288.00001173048, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 186.000007575935,
      op: 1687.00006871292,
      st: 186.000007575935,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 2,
      nm: 'Group 45065.png',
      cl: 'png',
      refId: 'image_4',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [425, 194, 0], ix: 2, l: 2 },
        a: { a: 0, k: [305, 94, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 93,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 111,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.567, 0.567, 0.667], y: [1, 1, 1] },
              o: { x: [0.441, 0.441, 0.333], y: [0, 0, 0] },
              t: 129,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 186,
              s: [100, 100, 100],
            },
            { t: 195.000007942513, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 93.0000037879676,
      op: 1594.00006492495,
      st: 93.0000037879676,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 2,
      nm: 'Mask Group 40991.png',
      cl: 'png',
      refId: 'image_5',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [420, 464, 0], ix: 2, l: 2 },
        a: { a: 0, k: [243, 125, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 93,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 111,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.567, 0.567, 0.667], y: [1, 1, 1] },
              o: { x: [0.441, 0.441, 0.333], y: [0, 0, 0] },
              t: 129,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 186,
              s: [100, 100, 100],
            },
            { t: 195.000007942513, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 93.0000037879676,
      op: 1594.00006492495,
      st: 93.0000037879676,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 2,
      nm: 'Mask Group 40990.png',
      cl: 'png',
      refId: 'image_6',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [428, 405, 0], ix: 2, l: 2 },
        a: { a: 0, k: [140, 145, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 18,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.567, 0.567, 0.667], y: [1, 1, 1] },
              o: { x: [0.441, 0.441, 0.333], y: [0, 0, 0] },
              t: 36,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 93,
              s: [100, 100, 100],
            },
            { t: 102.000004154545, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 1501.00006113698,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 2,
      nm: 'Group 45064.png',
      cl: 'png',
      refId: 'image_7',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [425, 142, 0], ix: 2, l: 2 },
        a: { a: 0, k: [305, 94, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [0, 0, 100],
            },
            {
              i: { x: [0.351, 0.351, 0.667], y: [1, 1, 1] },
              o: { x: [0.675, 0.675, 0.333], y: [0, 0, 0] },
              t: 18,
              s: [110, 110, 100],
            },
            {
              i: { x: [0.567, 0.567, 0.667], y: [1, 1, 1] },
              o: { x: [0.441, 0.441, 0.333], y: [0, 0, 0] },
              t: 36,
              s: [100, 100, 100],
            },
            {
              i: { x: [0, 0, 0.667], y: [1, 1, 1] },
              o: { x: [1, 1, 0.333], y: [0, 0, 0] },
              t: 93,
              s: [100, 100, 100],
            },
            { t: 102.000004154545, s: [0, 0, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 1501.00006113698,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 2,
      nm: 'Base premios',
      refId: 'image_8',
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [437, 334, 0], ix: 2, l: 2 },
        a: { a: 0, k: [457, 379, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 1501.00006113698,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
}

